import Axios from "@/plugins/Axios";

export class RelatoriosService {
  async carteira(matricula) {
    const response = await Axios()
      .get(`relatorios/cartao/${matricula}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `carteira_${matricula}.pdf`;
        link.click();
      });
    return response;
  }

  async listarTurma(turma) {
    const response = await Axios()
      .get(`relatorios/listarTurma/${turma}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `listar_turma_${turma}.pdf`;
        link.click();
      });
    return response;
  }

  async boletimGeral(turma) {
    const response = await Axios()
      .get(`relatorios/boletimGeral/${turma}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = `boletim_turma_${turma}.pdf`;
        // link.click();
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatorioBNCC(matricula_id) {
    const response = await Axios()
      .get(`relatorios/relatorioBNCC/${matricula_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = `ralatorio_bncc_matricula_${matricula_id}.pdf`;
        // link.click();
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async boletimIndividual(matricula_id) {
    const response = await Axios()
      .get(`relatorios/turmaBoletimIndividual/${matricula_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = `boletim_individual_matricula_id_${matricula_id}.pdf`;
        // link.click();
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatorioAee(matricula_id) {
    const response = await Axios()
      .get(`relatorios/relatorio-aee/${matricula_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorio_do_atendimento_educacional_especial_matricula_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async boletinsFranquia(franquia_id, turmasSelecionadas) {
    const response = await Axios()
      .post(
        `relatorios/boletins-franquia/${franquia_id}`,
        { turmas: turmasSelecionadas },
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `boletins_franquia_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async boletinsFranquiaAlunosTransferidos(franquia_id, turmasSelecionadas) {
    const response = await Axios()
      .post(
        `relatorios/boletins-franquia-alunos-transferidos/${franquia_id}`,
        { turmas: turmasSelecionadas },
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `BOLETINS - ALUNOS TRANSFERIDOS.pdf`;
        link.click();
      });
    return response;
  }

  async escolasTurmasAlunos() {
    const response = await Axios()
      .get("relatorios/escolas_turmas_alunos", { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "escola_relatorio_completo.pdf";
        link.click();
      });
    return response;
  }

  async mapaDeMatriculasEscolas() {
    const response = await Axios()
      .get("relatorios/mapa_matriculas_escolas", { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "mapa_matriculas_escolas.pdf";
        link.click();
      });
    return response;
  }

  async listarTodasTurmas() {
    const response = await Axios()
      .get("relatorios/listar-todas-turmas", { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "todas_as_turmas_de_todas_escolas.pdf";
        link.click();
      });
    return response;
  }

  async listarTurmasFranquia(franquia_id) {
    const response = await Axios()
      .get(`relatorios/listar-turmas-franquia/${franquia_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "todas_as_turmas_de_uma_escola.pdf";
        link.click();
      });
    return response;
  }

  async inscritosCongresso() {
    const response = await Axios()
      .get("relatorios/inscritos-congresso", { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "inscritos_congresso.pdf";
        link.click();
      });
    return response;
  }

  async diarioFrequencia(gestao_id, mes) {
    const { id } = mes;
    const response = await Axios()
      .get(`relatorios/diario-frequencia/${gestao_id}/${id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `diario_frequencia_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async diarioAulas(gestao_id, mes) {
    const { id } = mes;
    const response = await Axios()
      .get(`relatorios/diario-aulas/${gestao_id}/${id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `diario_aulas_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async diarioNotas(gestao_id, disciplina_id = null) {
    let url = `relatorios/diario-notas/${gestao_id}`;
    if (disciplina_id) {
      url += `/${disciplina_id}`;
    }

    const response = await Axios()
      .get(url, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const filename = disciplina_id
          ? `diario_notas_${gestao_id}_disciplina_${disciplina_id}.pdf`
          : `diario_notas_${gestao_id}.pdf`;
        link.download = filename;
        link.click();
      });
    return response;
  }

  async relatorioBNCCTurma(turma_id) {
    const response = await Axios()
      .get(`relatorios/relatorio-bncc/${turma_id}/turma`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Relatorio-BNCC-Turma-${turma_id}.pdf`;
        link.click();
        return response;
      });
  }

  async insercaoAulas() {
    const response = await Axios()
      .get("relatorios/insercao-aulas", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "insercao_aulas.pdf";
        link.click();
      });
    return response;
  }

  async lotacaoGeral() {
    const response = await Axios()
      .get("relatorios/relatorio-lotacao-geral", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "relatorio_lotacao_geral.pdf";
        link.click();
      });
    return response;
  }

  async lotacao() {
    const response = await Axios()
      .get("relatorios/relatorio-lotacao", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "relatorio_lotacao.pdf";
        link.click();
      });
    return response;
  }

  async lotacaoEscola(franquia_id) {
    const response = await Axios()
      .get(`relatorios/relatorio-lotacao-escola/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorio_lotacao_escola_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async planoBimestral(gestao_id, bimestre, disciplina_id) {
    const response = await Axios()
      .get(`relatorios/plano-bimestral/${gestao_id}/${bimestre}/${disciplina_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `plano_bimestral_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async planoMensal(gestao_id, mes_id, disciplina_id) {
    const response = await Axios()
      .get(`relatorios/plano-mensal/${gestao_id}/${mes_id}/${disciplina_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `plano_bimestral_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async resultadoPorDisciplina(turma) {
    const response = await Axios()
      .get(`relatorios/resultado-por-disciplinas/${turma}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `resultado_por_disciplina_${turma}.pdf`;
        link.click();
      });
    return response;
  }

  async ataFinalTurmaInfantil(turma) {
    const response = await Axios()
      .get(`relatorios/ata-final-turma-infantil/${turma}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `ata_final_infantil_${turma}.pdf`;
        link.click();
      });
    return response;
  }

  async capaDiarioClasse(gestao_id) {
    const response = await Axios()
      .get(`relatorios/capa/diario-classes/${gestao_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `capa_de_diario_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async resumoMovimentoEscolar(franquia_id) {
    const response = await Axios()
      .get(`relatorios/resumo-movimento-escolar/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `resumo_movimento_escolar_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async declaracaoConclusao(matricula_id) {
    const response = await Axios()
      .get(`relatorios/declaracao-conclusao/${matricula_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `declaracao_de_conclusao_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async declaracaoTransferencia(matricula_id) {
    const response = await Axios()
      .get(`relatorios/declaracao-transferencia/${matricula_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `declaracao_de_transferencia_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async declaracaoCurso(matricula_id) {
    const response = await Axios()
      .get(`relatorios/declaracao-curso/${matricula_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `declaracao_de_curso_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async fichaDeMatricula(matricula_id) {
    const response = await Axios()
      .get(`relatorios/ficha-matricula/${matricula_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `ficha_de_matricula_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async fichaDeMatriculaEncaminhamentoEscolar(matricula_id, dados) {
    const response = await Axios()
      .post(`relatorios/ficha-encaminhamento-escolar/${matricula_id}`, dados, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = `ficha_de_matricula_${matricula_id}.pdf`;
        // link.click();
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async documentoJustificativaFalta(aula_id, matricula_id) {
    const response = await Axios()
      .get(`relatorios/falta/baixar-documento/${aula_id}/${matricula_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `documento_de_justificativa_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async frenquenciaIndividual(matricula_id, mes) {
    const response = await Axios()
      .get(`relatorios/frenquencia-individual/${matricula_id}/${mes}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `frequencia_individual_${matricula_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioAuxiliar(gestao_id, disciplina_id, mes) {
    const response = await Axios()
      .get(`relatorios/relatorio-auxiliar/${gestao_id}/${disciplina_id}/${mes}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorio_auxiliar_${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async planoBimestralInfantil(gestao_id, bimestre) {
    const response = await Axios()
      .get(`relatorios/plano-bimestral-infantil/${gestao_id}/${bimestre}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `plano_bimestral_infantil${gestao_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioDeListagemDosPlanosLancados(franquia_id) {
    const response = await Axios()
      .get(`relatorios/historico-lancamentos-planos/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `historico_lancamento_planos_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioDeListagemDosPlanosLancadosGeral() {
    const response = await Axios()
      .get(`relatorios/historico-lancamentos-planos-geral`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `historico_lancamento_planos_geral.pdf`;
        link.click();
      });
    return response;
  }

  async relatoriosEvasao(franquia_id, turmasSelecionadas) {
    const response = await Axios()
      .post(
        `relatorios/evasao/${franquia_id}`,
        { turmas: turmasSelecionadas },
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorio_evasao_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatoriosEvasaoProfessor(franquia_id, month) {
    const response = await Axios()
      .get(`relatorios/evasao-professor/${franquia_id}/${month}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async alunosNaoMatriculados(franquia_id) {
    const response = await Axios()
      .get(`relatorios/alunos-nao-matriculados/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `alunos_nao_matriculados_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async alunosNaoMatriculadosGeral() {
    const response = await Axios()
      .get(`relatorios/alunos-nao-matriculados-geral`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `alunos_nao_matriculados_geral.pdf`;
        link.click();
      });
    return response;
  }

  async qtdProfessoresPorDisciplina() {
    const response = await Axios()
      .get(`relatorios/professores-por-disciplina`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `qtd_professores_por_disciplina.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioDescritivo(matricula_id, gestao_id, semestre) {
    const response = await Axios()
      .get(`relatorios/relatorio-descritivo/${matricula_id}/${gestao_id}?semestre=${semestre}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatoriosCensoFranquia(franquias_id) {
    const response = await Axios()
      .get(`relatorios/censo/${franquias_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `censo_${franquias_id}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioDiarioAtendimento(matricula_id, gestao_id) {
    const response = await Axios()
      .get(`relatorios/relatorio-diario-atendimento/${matricula_id}/${gestao_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatorioEspecialDesenvolvimentoBimestral(matricula_id, gestao_id, bimestre_id) {
    const response = await Axios()
      .get(
        `relatorios/relatorio-especial-desenvolvimento-bimestral/${matricula_id}/${gestao_id}/${bimestre_id}`,
        {
          responseType: "arraybuffer",
        }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async professoresTodasEscolas() {
    const response = await Axios()
      .get("relatorios/relatorio-professores-todas-escolas", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "relatorio_lotacao_professores_todas_escolas.pdf";
        link.click();
      });
    return response;
  }

  async relatoriosMovimentacaoMatricula(mes) {
    const response = await Axios()
      .get(`relatorios/movimentacao-matriculas/${mes}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async alunosPorUnidadeEScolar(franquia_id) {
    const response = await Axios()
      .get(`relatorios/alunos_por_unidade/${franquia_id}`, { responseType: "arraybuffer" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "alunos_por_unidade.pdf";
        link.click();
      });
    return response;
  }

  async relatoriosQtdUsoDoSistema(mes, franquia_id, tipoRelatorioUso) {
    const response = await Axios()
      .get(`relatorios/qtd-uso-do-sistema/franquia/${mes}/${franquia_id}/${tipoRelatorioUso}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatoriosQtdUsoDoSistemaAnual(franquia_id, tipoRelatorioUso) {
    const response = await Axios()
      .get(`relatorios/qtd-uso-do-sistema-anual/franquia/${franquia_id}/${tipoRelatorioUso}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatorioPlanejamentoMensalAEE(matricula_id, gestao_id, mes_id) {
    const response = await Axios()
      .get(`relatorios/planejamento-mensal-aee/${matricula_id}/${gestao_id}/${mes_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    return response;
  }

  async relatorioPlanoAEE(matricula_id, gestao_id) {
    await Axios()
      .get(`relatorios/plano-aee/${matricula_id}/${gestao_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }

  async relatoriosBnccFranquia(franquia_id, turmasSelecionadas) {
    const response = await Axios()
      .post(
        `relatorios/relatorios-bncc-franquia/${franquia_id}`,
        { turmas: turmasSelecionadas },
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `relatorios_bncc_franquia_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async DesempenhoProfessorPorFranquia(franquia_id) {
    const response = await Axios()
      .get(`relatorios/franquia/${franquia_id}/usabilidade-professores`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `desempenho_professor_franquia_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async alunosNecessidadesEspeciais(franquia_id) {
    const response = await Axios()
      .get(`relatorios/alunos_necessidades_especiais/${franquia_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "alunos_necessidades_especiais.pdf";
        link.click();
      });
    return response;
  }

  async DesempenhoProfessorPorTurma(franquia_id, turmasSelecionadas) {
    const response = await Axios()
      .post(
        `relatorios/turma/${franquia_id}/usabilidade-professores`,
        { turmas: turmasSelecionadas },
        { responseType: "arraybuffer" }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `desempenho_professor_turma_${franquia_id}.pdf`;
        link.click();
      });
    return response;
  }

  async alunosMatriculadosXls() {
    const response = await Axios()
      .get("relatorios/alunos-matriculados-xls", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/xls" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "alunos_matriculados.xls";
        link.click();
      });
    return response;
  }

  async professoresPlanilhaXls() {
    const response = await Axios()
      .get("relatorios/professores-planilha-xls", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/xls" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "professores.xls";
        link.click();
      });
    return response;
  }
}
export default new RelatoriosService();
